import React from 'react';
import { ProceedingForm } from '../components/ProceedingForm';
import AppLayout from '../components/AppLayout';

function CreateProceedingPage() {
  return (
    <>
      <AppLayout />
      <ProceedingForm />
    </>
  );
}

export default CreateProceedingPage;
